/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Category_TrainerInputs */

const en_us2_community_category_trainer = /** @type {(inputs: Community_Category_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainer`)
};

const pt_br2_community_category_trainer = /** @type {(inputs: Community_Category_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinador`)
};

const es_419_community_category_trainer = /** @type {(inputs: Community_Category_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenador`)
};

const pt_pt2_community_category_trainer = /** @type {(inputs: Community_Category_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinador`)
};

const fr_fr2_community_category_trainer = /** @type {(inputs: Community_Category_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

const de_de2_community_category_trainer = /** @type {(inputs: Community_Category_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

const it_it2_community_category_trainer = /** @type {(inputs: Community_Category_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

/**
* | output |
* | --- |
* | "Trainer" |
*
* @param {Community_Category_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_category_trainer = /** @type {((inputs?: Community_Category_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Category_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_category_trainer(inputs)
	if (locale === "es-419") return es_419_community_category_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_community_category_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_community_category_trainer(inputs)
	if (locale === "de-DE") return de_de2_community_category_trainer(inputs)
	if (locale === "it-IT") return it_it2_community_category_trainer(inputs)
	return en_us2_community_category_trainer(inputs)
});
export { community_category_trainer as "community.category_trainer" }